// Logo.js
import React from 'react';
import { Droplet } from 'lucide-react';

const Logo = ({ expanded = false, size = "normal" }) => {
    const iconSize = size === "large" ? "w-8 h-8" : "w-7 h-7";
    const textSize = size === "large" ? "text-2xl" : "text-xl";

    if (!expanded) {
        return <Droplet className={`${iconSize} text-blue-900`} />;
    }

    return (
        <div className="flex items-center gap-3">
            <Droplet className={`${iconSize} text-blue-900`} />
            <span className={`${textSize} font-bold text-blue-900`}>DIO+</span>
        </div>
    );
};

export default Logo;